var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "page-container",
      },
      [
        _c(
          "el-collapse",
          {
            on: {
              change: (e) => {
                _vm.showSearchParams = e.length > 0
              },
            },
            model: {
              value: _vm.activeName,
              callback: function ($$v) {
                _vm.activeName = $$v
              },
              expression: "activeName",
            },
          },
          [
            _c(
              "el-collapse-item",
              { attrs: { name: "1" } },
              [
                _c("template", { slot: "title" }, [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.showSearchParams,
                          expression: "!showSearchParams",
                        },
                      ],
                      on: {
                        click: function ($event) {
                          _vm.showSearchParams = !_vm.showSearchParams
                        },
                      },
                    },
                    [
                      _vm._v(_vm._s(_vm.$t("show_confirmation_overview"))),
                      _c("i", { staticClass: "el-icon-arrow-down" }),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showSearchParams,
                          expression: "showSearchParams",
                        },
                      ],
                      on: {
                        click: function ($event) {
                          _vm.showSearchParams = !_vm.showSearchParams
                        },
                      },
                    },
                    [
                      _vm._v(_vm._s(_vm.$t("hide_confirmation_overview"))),
                      _c("i", { staticClass: "el-icon-arrow-up" }),
                    ]
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "summary" },
                  _vm._l(
                    _vm.summary.filter((vv) =>
                      _vm.showConfirmationReplyStatus
                        ? true
                        : ![5, 6].includes(vv.id)
                    ),
                    function (v) {
                      return _c(
                        "div",
                        {
                          key: v.id,
                          class: [
                            "summary-item",
                            _vm.activeSummary === v.id ? "active" : "",
                            _vm.showConfirmationReplyStatus
                              ? "summary-item-small"
                              : "",
                            _vm.updateGuide &&
                            _vm.updateGuideStep === 1 &&
                            v.id == 2
                              ? "updateGuideIcon"
                              : "",
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.filterStatus(v)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "summary-item-value" }, [
                            _vm._v(_vm._s(v.value)),
                          ]),
                          _c("div", {
                            class: [
                              "summary-item-title",
                              _vm.$i18n.locale === "en" ? "en-cls" : "",
                            ],
                            domProps: { innerHTML: _vm._s(v.title) },
                          }),
                          _vm.updateGuide &&
                          _vm.updateGuideStep === 1 &&
                          v.id == 2
                            ? _c(
                                "div",
                                { staticClass: "updateGuideTip" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "margin-bottom-10" },
                                    [_vm._v("1/5")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "margin-bottom-10" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("confirmation_bubble_1"))
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "guide-btn",
                                      on: { click: _vm.nextClick },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("next")))]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      )
                    }
                  ),
                  0
                ),
              ],
              2
            ),
          ],
          1
        ),
        _c("DetailTable", {
          ref: "detailTable",
          class: [
            "detail-info-container",
            _vm.showSearchParams ? "show-params" : "",
          ],
          attrs: {
            activeSummary: _vm.activeSummary,
            loading: _vm.loading,
            showSearchParams: _vm.showSearchParams,
            getOverviewData: _vm.getOverviewData,
            updateGuide: _vm.updateGuide,
            updateGuideStep: _vm.updateGuideStep,
            nextClick: _vm.nextClick,
          },
          on: {
            "update:activeSummary": function ($event) {
              _vm.activeSummary = $event
            },
            "update:active-summary": function ($event) {
              _vm.activeSummary = $event
            },
            "update:loading": function ($event) {
              _vm.loading = $event
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }